<template>
    <div>
        <div id="top">
            <iframe
                style="    border: none;
                width: 92%;
                overflow: hidden;
                position: relative;
                top: 35%;
                left: 4%;
                height: 60%;"
                v-bind:src="baseUrl+'index/index/cont'"
            ></iframe>
        </div>
        <div id="bottom">
            <div class="bg"></div>
            <div id="hxt"><Chartc></Chartc></div>
            <div id="huan" style="width: 100%;height: 350px;"></div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import Chartc from '@/components/Chartc'
export default {
    name: 'charta',
    components: {
        Chartc
    },
    data(){
        return{
            baseUrl: '',
            content:"",
        }
    },
    mounted () {
        this.baseUrl = 'https://huhang.jinxinzhucan.com/'
        // this.baseUrl = this.$url.baseUrl
        console.log(this.baseUrl,"链接")
        this.huan()
        this.clickTimes()
    },
    methods: {
        clickTimes(){
            this.timer = setInterval(() => {
                this.huan()
            }, 10000)
        },
        huan(){
            var that = this
            that.axios.post(this.$url.baseUrl+'index/userlist', {

                headers: {
                    'Content-Type':'application/x-www-form-urlencoded',
                }
            })
            .then(function (res) {
                console.log(res.data.data,"BB")
                if(res.data.code == 1){
                    that.content = res.data.data.about
                    that.company = res.data.data.company
                    that.zx = res.data.data.zx
                    that.yc = res.data.data.yc
                    that.lx = res.data.data.lx

                    console.log(that.zx)
                    console.log(that.yc)
                    console.log(that.lx)
                    console.log(that.company)


                    var chartDom = document.getElementById('huan');
                    var myChart = echarts.init(chartDom);
                    var option;

                    option = {
                        title: {
                            text: '   各企业使用人数',
                            textStyle: {
                                color: '#FFFFFF',
                                align: 'center'
                            },
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                // Use axis to trigger tooltip
                                type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                            }
                        },
                        legend: {
                            x: 'right',
                            data: [
                                {
                                    name: '在线正常',
                                    textStyle: {
                                        color: '#38EC91'
                                    },
                                },
                                {
                                    name: '离线',
                                    textStyle: {
                                        color: '#727388'
                                    },
                                },
                                {
                                    name: '在线异常',
                                    textStyle: {
                                        color: '#FF6D77'
                                    },
                                },
                            ]
                        },
                        grid: {
                            show: false,
                            left: '20%', // 调整这个属性
                            borderWidth: 0,
                        },
                        xAxis: {
                            type: 'value',
                            splitLine: {
                                show:false
                            },
                            axisLine:{//x轴、y轴的深色轴线，如图2
                                show: false
                            },
                            axisTick:{
                                show:false   //刻度线
                            },
                            data: that.xAxis,
                            axisLabel: {
                                show: false,
                                color: '#ffffff',
                                fontSize: 12
                            }
                        },
                        yAxis: {
                            type: 'category',
                            splitLine: {
                                show:false
                            },
                            axisLine:{//x轴、y轴的深色轴线，如图2
                                show: false
                            },
                            axisTick:{
                                show:false   //刻度线
                            },
                            axisLabel: {
                                show: true,
                                color: '#ffffff',
                                fontSize: 12
                            },
                            data: that.company
                        },
                        series: [
                            {
                                name: '在线正常',
                                type: 'bar',
                                stack: 'total',
                                label: {
                                    show: true
                                },
                                emphasis: {
                                    focus: 'series'
                                },
                                itemStyle: {//自定义颜色,
                                    color: '#38EC91',
                                    normal: { color: "#38EC91" }
                                },
                                data: that.zx
                            },
                            {
                                name: '离线',
                                type: 'bar',
                                stack: 'total',
                                label: {
                                    show: true
                                },
                                emphasis: {
                                    focus: 'series'
                                },
                                itemStyle: {//自定义颜色
                                    normal: { color: "#727388" },
                                },
                                data: that.lx
                            },
                            {
                                name: '在线异常',
                                type: 'bar',
                                stack: 'total',
                                label: {
                                    show: true
                                },
                                emphasis: {
                                    focus: 'series'
                                },
                                itemStyle: {//自定义颜色
                                    normal: { color: "#FF6D77" },
                                },
                                data: that.yc
                            },

                        ]
                    };

                    option && myChart.setOption(option);


                }
            })
            .catch(function (error) {
                console.log(error);
            });


        },
    }
}
</script>
<style scoped>
#huan{
    z-index: 2;
    width: 100%;
    height: 60%;
    top: 0;
    position: relative;
}
#huan div{
    width: 100% !important;
}
#hxt{
    z-index: 2;
    padding-top: 12%;
}
</style>



// WEBPACK FOOTER //
// src/components/Charta.vue